import { render, staticRenderFns } from "./fluxoCaixa.vue?vue&type=template&id=6f54cca6&scoped=true&"
import script from "./fluxoCaixa.vue?vue&type=script&lang=js&"
export * from "./fluxoCaixa.vue?vue&type=script&lang=js&"
import style0 from "./fluxoCaixa.vue?vue&type=style&index=0&id=6f54cca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54cca6",
  null
  
)

export default component.exports